/**
 * Tracks whether AdSense has actually served an ad on this site.
 *
 * The "please allow ads" notice must stay completely hidden until AdSense is
 * genuinely serving — otherwise visitors are asked to whitelist a site that
 * shows no ads at all. AdSense marks a filled unit with
 * `data-ad-status="filled"`, which is the only reliable serving signal
 * available client-side.
 */

const STORAGE_KEY = "statlign:ads-served";

let served = false;
const listeners = new Set<() => void>();

try {
  served = typeof localStorage !== "undefined" && localStorage.getItem(STORAGE_KEY) === "1";
} catch {
  served = false;
}

export function adsHaveServed(): boolean {
  return served;
}

export function markAdsServed() {
  if (served) return;
  served = true;
  try {
    localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    /* storage may be blocked — in-memory flag still works for this session */
  }
  for (const l of listeners) l();
}

export function subscribeAdsServed(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
